import { callAPI, HTTPMethod } from "./API";
import {NonIntegratedCfdi } from "../model/CfdisNonIntegrated";

const getBaseUrl = (tenantId: string, providerId: string) => {
    return `/tenants/${tenantId}/providers/${providerId}/non-integrated-cfdis/`;
};

export async function listCancellationRequested(tenantId: string, providerId: string, validateSat : boolean) : Promise<NonIntegratedCfdi[]>{
    return await callAPI(`${getBaseUrl(tenantId, providerId)}cancellation-requested`, {
        method: HTTPMethod.GET,
        query: {
            validateSat : validateSat.toString()
        }
    });
}

